import React from "react";

import indexOf from "lodash/indexOf";
import forEach from "lodash/forEach";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import FormHelperText from "@material-ui/core/FormHelperText";

import useStyles from "../styles";

const SelectField = (props) => {
  const { options, field, form, label } = props;

  const classes = useStyles();

  let otherProps = {};

  if (form.errors[field.name] && form.touched[field.name]) {
    otherProps.helperText = form.errors[field.name];
    otherProps.error = true;
  }

  if (props.multiple) {
    otherProps.multiple = true;

    otherProps.renderValue = (selected) => {
      const renderValue = [];

      forEach(options, (val) => {
        if (indexOf(selected, val.value) > -1) {
          renderValue.push(val.name);
        }
      });

      return renderValue.join(", ");
    };
  }

  const handleChange = (e) => {
    let val = e.target.value;

    form.setFieldValue(field.name, val);

    if (props.cstmOnChange) {
      props.cstmOnChange({ ...form.values, [field.name]: val });
    }
  };

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      {...props.formControlStyle}
    >
      <InputLabel {...otherProps}>{label}</InputLabel>
      <Select
        label={label}
        value={field.value}
        onChange={handleChange}
        {...otherProps}
      >
        {options.map((option) => (
          <MenuItem key={option.name} value={option.value}>
            {props.multiple ? (
              <React.Fragment>
                <Checkbox checked={indexOf(field.value, option.value) > -1} />
                <ListItemText primary={option.name} />
              </React.Fragment>
            ) : (
              option.name
            )}
          </MenuItem>
        ))}
      </Select>

      {otherProps.error && (
        <FormHelperText {...otherProps}>{otherProps.helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/SelectField.js